import { render, staticRenderFns } from "./TicketSystem.vue?vue&type=template&id=37f2fe35&scoped=true"
import script from "./TicketSystem.vue?vue&type=script&lang=js"
export * from "./TicketSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f2fe35",
  null
  
)

export default component.exports